export default __webpack_public_path__ + "static/media/bee.7ec752cc.svg";